module.exports = __webpack_public_path__ + "img/icon-trash-disable.64d0bc8f.svg";